import { axios } from '@zyf2e/adapt';
import { env } from '@/config';

const http = opt => {
  const { url, method, params, config = {} } = opt;
  // mock环境
  if (env === 'mock') {
    const fileName = url.replace(/\//g, '^');
    const mock = require(`../mock/${fileName}${method}.json`);
    return Promise.resolve(mock.result);
  }

  const formatParams = method === 'Get' ? { params } : params;
  return axios[method.toLocaleLowerCase()](url, formatParams, config);
};

export default http;
